import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3415 8088 c-5 -13 335 -879 376 -959 l19 -39 728 -2 727 -3 -60 -29
c-33 -15 -89 -41 -125 -56 -68 -29 -313 -136 -490 -214 -58 -26 -160 -70 -227
-99 -85 -36 -125 -58 -132 -74 -9 -20 -69 -294 -93 -425 l-10 -58 -439 0
c-392 0 -440 -2 -446 -16 -5 -14 59 -195 109 -304 11 -24 45 -110 75 -190 30
-80 63 -163 72 -185 10 -22 41 -99 70 -172 29 -72 58 -139 66 -150 13 -17 45
-18 614 -23 l601 -5 -78 -34 c-159 -70 -251 -111 -404 -180 -87 -39 -160 -71
-163 -71 -4 0 -34 -13 -68 -29 -34 -16 -93 -43 -132 -61 -164 -75 -175 -81
-180 -103 -7 -31 -42 -202 -70 -340 -13 -64 -27 -122 -30 -127 -4 -6 -116 -10
-301 -10 -334 0 -311 7 -269 -89 13 -31 53 -130 89 -221 128 -330 278 -705
283 -710 10 -11 2578 -10 2693 1 137 12 224 31 331 70 275 100 512 284 732
569 62 79 155 266 196 390 59 179 74 276 75 475 0 201 -14 296 -66 454 -39
120 -141 320 -216 424 -67 95 -212 244 -297 307 -33 24 -70 53 -82 63 l-22 19
39 77 c112 222 159 447 146 716 -8 174 -27 289 -72 419 -170 498 -534 843
-1026 973 l-103 27 -1218 4 c-987 2 -1218 0 -1222 -10z m2277 -1018 c146 -45
258 -161 314 -327 12 -35 15 -74 12 -152 -3 -97 -6 -112 -39 -181 -45 -92 -91
-146 -170 -199 -106 -71 -158 -81 -408 -81 -120 0 -220 2 -223 5 -2 3 6 55 19
117 46 221 132 634 148 713 9 44 18 90 21 103 4 21 8 22 133 22 100 0 143 -4
193 -20z m549 -2017 c85 -42 148 -98 197 -176 50 -80 72 -144 79 -233 14 -172
-81 -352 -230 -440 -125 -73 -76 -69 -837 -69 -603 0 -685 2 -684 15 1 8 16
80 32 160 17 80 56 264 86 410 30 146 60 289 66 318 l12 53 607 -3 606 -3 66
-32z"
          />
          <path d="M4461 2804 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M3197 2273 c-4 -3 -7 -15 -7 -25 0 -17 74 -18 2216 -18 l2215 0 -3
23 -3 22 -2206 3 c-1213 1 -2209 -1 -2212 -5z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
